// ======================================================================
// File Name       : RegisterMessageConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import { Form, Button, Col } from 'react-bootstrap';
import { MODE } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER, MESSAGE_OPERATION_FLAG } from '../../constants/MessageThreadContants';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import { SENT_MESSAGE_LIST } from '../../constants/PathConstants';
import Header from '../../components/Header';
import ModalWrapper from '../../components/modal/ModalWrapper';
import RegisterMessageUserList from '../../components/messageThread/RegisterMessageUserList';

class RegisterMessageConfirmContainer extends React.Component {
  constructor(props) {
    super(props);
    this.createParam = this.createParam.bind(this);
    this.registerMessageThread = this.registerMessageThread.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  registerMessageThread() {
    const { invalid, formValues } = this.props;
    if (invalid || !formValues) {
      return;
    }
    const param = this.createParam(formValues);
    const { dispatch, history } = this.props;
    dispatch(this.props.hideModal());
    dispatch(MessageThreadAction.registerEditMessageThread(param)).then(() => {
      history.push(SENT_MESSAGE_LIST);
    });
  }

  createParam(formValues) {
    const param = {};
    param.editType = MODE.NEW_MODE;
    const messageInfo = {};
    messageInfo.messageType = MESSAGE_TYPE.ROUTE;
    messageInfo.messageTitle = formValues.messageTitle || null;
    messageInfo.messageContent = formValues.messageContent;
    if (formValues && formValues.messageOperationFlag) {
      messageInfo.messageOperationFlag = MESSAGE_OPERATION_FLAG.CHECK;
    }
    param.messageInfo = messageInfo;
    formValues.attachmentFile &&
      formValues.attachmentFile.length &&
      (param.attachmentFile = formValues.attachmentFile[0]);
    formValues.edittingUserList && (param.edittingUserList = formValues.edittingUserList);
    return param;
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        {
          name: 'OK',
          onClick: this.registerMessageThread,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const { messageTitle, messageContent, attachmentFile, messageOperationFlag } = this.props.formValues;
    const { edittingUsers } = this.props;
    let attachmentFileName = '';
    if (attachmentFile && attachmentFile.length) {
      attachmentFileName = attachmentFile[0].name;
    }
    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.props.hideModal} fixedHeight={false} >
        <div>
          <div style={{ textAlign: 'left', paddingLeft: '15px' }}>
            <Header name="この内容でメッセージを作成します" />
          </div>
          <Form className='form-horizontal ps-0'>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                スレッドタイトル
              </Col>
              <Col as={Form.Label} sm={7}>{messageTitle}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                スレッド詳細
              </Col>
              <Col as={Form.Label} sm={7}>{messageContent}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                添付ファイル
              </Col>
              <Col as={Form.Label} sm={7}>{attachmentFileName}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={12} className='margin-left-15'>
                <Form.Check
                  type='checkbox'
                  className="cursor-default"
                  name="messageOperationFlag"
                  id="messageOperationFlagConfirm"
                  disabled
                  checked={messageOperationFlag}
                  label='送信先ユーザーを指定しない'
                />
              </Col>
            </Form.Group>
          </Form>
          <div className="margin-left-15">
            <RegisterMessageUserList edittingUsers={edittingUsers} isConfirm />
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  storedUsers: state.messageThread.storedUsers,
  edittingUsers: state.messageThread.edittingUsers,
  formValues: getFormValues('registerMessageThreadForm')(state),
});

export default connect(mapStateToProps)(RegisterMessageConfirmContainer);
